import React from "react";
import { useTranslation } from "react-i18next";

import { Card, CardBody, CardHeader, Table, Tbody, Td, Text, Th, Thead, Tr } from "@chakra-ui/react";

import FinancialStatementsRow from "./FinancialStatementsRow";

export default function PropertyFinancialStatementsCard({ statements, address, propertyId }) {
	const { t } = useTranslation();

	return (
		<Card overflowX={{ sm: "scroll", xl: "hidden" }} mb={4}>
			<CardHeader pb={2}>
				<Text fontSize="lg" fontWeight="medium">
					{address}
				</Text>
			</CardHeader>
			<CardBody pt={2}>
				<Table variant="simple" size="sm">
					<Thead>
						<Tr my=".8rem" pl="0px">
							<Th pl="0px">{t("table.name")}</Th>
							<Th>{t("table.type")}</Th>
							<Th>{t("table.addedDate")}</Th>
							<Th>{t("table.description")}</Th>
							<Th></Th>
						</Tr>
					</Thead>
					<Tbody>
						{statements?.map((statement, index) => (
							<FinancialStatementsRow key={index} statement={statement} propertyId={propertyId} />
						))}
						{statements?.length === 0 && (
							<Tr>
								<Td colSpan={5} textAlign="center">
									{t("financialStatements.noStatements")}
								</Td>
							</Tr>
						)}
					</Tbody>
				</Table>
			</CardBody>
		</Card>
	);
}
